var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-main"},[_c('alert',{attrs:{"is-error":true,"alert-message":_vm.alertMessage}}),_c('serpbook')],1)}
var staticRenderFns = []

export { render, staticRenderFns }